<ag-shr-modal-window #approveDenyReasonModalRef [title]="'Agent Status Activity'" [showSaveButton]="false">
  @if (approveDenyReasonModalRef?.popupComponent?.visible ?? false) {
    <ag-shr-approve-deny-reasons-grid
      [agentDbId]="agentDbId$ | async"
      [sourceType]="sourceType"
    ></ag-shr-approve-deny-reasons-grid>
  }
</ag-shr-modal-window>

<ag-shr-editor-toolbar
  [title]="'Agent Status Activity'"
  [agentDbId]="agentDbId$ | async"
  [isEditVisible]="canEdit"
  (clickEdit)="showListPopup()"
></ag-shr-editor-toolbar>

<ag-shr-approve-deny-reasons-grid
  class="approve-deny-reasons__data-grid"
  [title]="''"
  [agentDbId]="agentDbId$ | async"
  [isEditable]="false"
  [sourceType]="sourceType"
></ag-shr-approve-deny-reasons-grid>
